export enum RegistrationFlowStep {
    REGISTRATION = "REGISTRATION",
    PREFERENCES = "PREFERENCES",
    PHONE_COMPLETION = "PHONE_COMPLETION",
    PHONE_VERIFICATION = "PHONE_VERIFICATION",
    LEAD_AFTER_REGISTRATION = "LEAD_AFTER_REGISTRATION",
    MULTILEAD = "MULTILEAD",
    UPDATED_PREFERENCES = "UPDATED_PREFERENCES",
    UNLOCK_CHOICE = "UNLOCK_CHOICE",
    SENT_APPLICATIONS_SUMMARY = "SENT_APPLICATIONS_SUMMARY",
    NAME_COMPLETION = "NAME_COMPLETION"
}
export enum RegistrationFlowStep {
    REGISTRATION = "REGISTRATION",
    PREFERENCES = "PREFERENCES",
    PHONE_COMPLETION = "PHONE_COMPLETION",
    PHONE_VERIFICATION = "PHONE_VERIFICATION",
    LEAD_AFTER_REGISTRATION = "LEAD_AFTER_REGISTRATION",
    MULTILEAD = "MULTILEAD",
    UPDATED_PREFERENCES = "UPDATED_PREFERENCES",
    UNLOCK_CHOICE = "UNLOCK_CHOICE",
    SENT_APPLICATIONS_SUMMARY = "SENT_APPLICATIONS_SUMMARY",
    NAME_COMPLETION = "NAME_COMPLETION"
}
